export const BASE_URL = "https://triverseadvertising.com/assure_website/api2/";
